var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('v-row',{staticClass:"d-flex justify-center"},[_c('v-col',{attrs:{"cols":"12","md":"12","lg":"8","xl":"5"}},[_c('BasePageTitle',{attrs:{"title":_vm.$t('settings.pageTitle')}}),_c('TheSettingsContainer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }